import { Component } from '@angular/core';

@Component({
    selector: 'cmps-event-centre-card-actions',
    template: ` <div class="cmps-event-centre-card-actions--left">
            <ng-content select="[cmpsEventCentreCardActionsLeft]"></ng-content>
        </div>
        <div class="cmps-event-centre-card-actions--right">
            <ng-content select="[cmpsEventCentreCardActionsRight]"></ng-content>
        </div>`,
    host: {
        class: 'cmps-event-centre-card-actions',
    },
})
export class CardActionsComponent {}
